var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.38281V5.58281C16 4.46271 16 3.90266 15.782 3.47483C15.5903 3.09851 15.2843 2.79255 14.908 2.6008C14.4802 2.38281 13.9201 2.38281 12.8 2.38281H11.2C10.0799 2.38281 9.51984 2.38281 9.09202 2.6008C8.71569 2.79255 8.40973 3.09851 8.21799 3.47483C8 3.90266 8 4.46271 8 5.58281V6.38281M10 11.8828V16.8828M14 11.8828V16.8828M3 6.38281H21M19 6.38281V17.5828C19 19.263 19 20.1031 18.673 20.7448C18.3854 21.3093 17.9265 21.7682 17.362 22.0558C16.7202 22.3828 15.8802 22.3828 14.2 22.3828H9.8C8.11984 22.3828 7.27976 22.3828 6.63803 22.0558C6.07354 21.7682 5.6146 21.3093 5.32698 20.7448C5 20.1031 5 19.263 5 17.5828V6.38281",
    stroke: "#FF2D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a049c82d6c55b0fc6ccdd1e6a780e3e6.svg";
export { ForwardRef as ReactComponent };